// JAISIU-3473 — cursor-based upward pagination replaces the legacy
// `chatHistoryDisplayLimit` slicing. The DOM is now a window into the
// full transcript; the client owns the prepend/cursor lifecycle and
// the view simply renders every message it has.
export function resolveChatHistoryPaging(props: {
  messages?: unknown[];
  chatHistoryDisplayLimit?: number;
}): {
  history: unknown[];
  displayLimit: number;
  historyStart: number;
  hiddenCount: number;
  canLoadMore: boolean;
} {
  const history = Array.isArray(props.messages) ? props.messages : [];
  const displayLimit = history.length;
  return { history, displayLimit, historyStart: 0, hiddenCount: 0, canLoadMore: false };
}
